import React from "react";
import { NavLink } from "react-router-dom";
import { Nav } from "reactstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useKeycloak } from '@react-keycloak/web';
import { isAdminUser } from '../../../routes/AdminRoute';
import { SIDEBAR_DESKTOP_MIN_WIDTH } from '../../layoutBreakpoints';


const Sidebar = (props) => {
  const { t } = useTranslation();
  const { keycloak } = useKeycloak();

  const isAdmin = isAdminUser(keycloak);
  const visibleRoutes = props.routes.filter((route) => !route.adminOnly || isAdmin);

  const activeRoute = (routePath) => {
    // return history.location.pathname.includes(routePath) ? "selected" : "";
  };
  const settings = useSelector((state) => state.settings);
  /*--------------------------------------------------------------------------------*/
  /*Verifies if routeName is the one active (in browser input)                      */
  /*--------------------------------------------------------------------------------*/

  /*--------------------------------------------------------------------------------*/
  /*Its for scroll to to                    */
  /*--------------------------------------------------------------------------------*/

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const closeMobileSidebar = () => {
    if (window.innerWidth < SIDEBAR_DESKTOP_MIN_WIDTH) {
      document.getElementById("main-wrapper")?.classList.remove("show-sidebar");
    }
  };

  return (
    <aside
      className="left-sidebar"
      id="sidebarbg"
      data-sidebarbg={settings.activeSidebarBg}
    >
      <div className="scroll-sidebar">
        <PerfectScrollbar className="sidebar-nav">
          {/*--------------------------------------------------------------------------------*/}
          {/* Sidebar Menus will go here                                                */}
          {/*--------------------------------------------------------------------------------*/}
          <Nav id="sidebarnav">
            {visibleRoutes.map((prop, key) => {
                return (
                  /*--------------------------------------------------------------------------------*/
                  /* Adding Sidebar Item                                                            */
                  /*--------------------------------------------------------------------------------*/
                  <li
                    onClick={scrollTop}
                    className={
                      activeRoute(prop.name) +
                       " active active-pro" +
                      " sidebar-item"
                    }
                    key={key}
                  >
                    <NavLink
                      to={prop.path}
                      onClick={closeMobileSidebar}
                      className={({ isActive }) =>
                        isActive ? "sidebar-link active" : "sidebar-link"
                      }
                    >
                      <i className={prop.icon} />
                      <span className="hide-menu">{t("screens." + prop.name)}</span>
                    </NavLink>
                  </li>
                );
              })}
          </Nav>
        </PerfectScrollbar >
      </div >
    </aside >
  );
};

export default Sidebar;
